module.exports = __webpack_public_path__ + "img/TModern.65324024.png";